import { EvidenceActionTypes } from '../../../../../../constants/utility/evidence-actions.constants';

// Role definitions matching the component guards
const REVIEW_ROLES = ['Champion', 'Admin', 'Developer'];
const EDIT_ROLES = ['Capturer', 'Admin', 'Developer'];

const hasUserRole = (user, roles) => {
    const userRoles = user?.roles || [];
    return userRoles.some((role) => roles.includes(role));
};

/**
 * Determines the appropriate action for submitted evidence based on user roles and capture status.
 *
 * Decision Matrix:
 * ┌─────────────────────┬─────────────────┬─────────────────┬────────────┬─────────────────────────────────────┐
 * │ User Roles          │ Evidence Owner  │ Self-Review     │ Action     │ Rationale                           │
 * ├─────────────────────┼─────────────────┼─────────────────┼────────────┼─────────────────────────────────────┤
 * │ Pure Capturer       │ Self            │ N/A             │ EDIT       │ Capturers can only capture/edit     │
 * │ Pure Capturer       │ Others          │ N/A             │ EDIT       │ Can "take over" others' evidence    │
 * │ Champion+           │ Self            │ Enabled         │ REVIEW     │ Self-review allowed                 │
 * │ Champion+           │ Self            │ Disabled        │ EDIT       │ Prevent self-approval               │
 * │ Champion+           │ Others          │ N/A             │ REVIEW     │ Can review others' work             │
 * │ Admin/Developer     │ Any             │ Any             │ REVIEW     │ Full permissions                    │
 * └─────────────────────┴─────────────────┴─────────────────┴────────────┴─────────────────────────────────────┘
 */
export const determineSubmittedEvidenceAction = (rowData, user, canSelfReview) => {
    const userCapturedEvidence = rowData?.capturedByUser;
    const hasReviewRole = hasUserRole(user, REVIEW_ROLES);
    const hasEditRole = hasUserRole(user, EDIT_ROLES);

    if (userCapturedEvidence) {
        // User captured this evidence themselves
        if (hasReviewRole && canSelfReview) {
            // Self-review is enabled - allow review of own work
            return EvidenceActionTypes.REVIEW;
        }
        if (hasEditRole) {
            // Edit own work (Capturers or Champions when self-review disabled)
            return EvidenceActionTypes.EDIT;
        }
    } else {
        // User did not capture this evidence
        if (hasReviewRole) {
            // Can review others' work
            return EvidenceActionTypes.REVIEW;
        }
        if (hasEditRole) {
            // Capturers can "take over" others' evidence
            return EvidenceActionTypes.EDIT;
        }
    }

    // Fallback
    return EvidenceActionTypes.EDIT;
};
